"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ErrorButton = require("./ErrorButton");
Object.keys(_ErrorButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorButton[key];
    }
  });
});
